import React, { useContext, useEffect, useState } from 'react'

import { firestore } from '../../../firebase';
import StateContext from '../../../StateContext';

function EditProfileDetails({author}) {

    const appState = useContext(StateContext)

    const [name, setName] = useState(author.name);
    const [message, setMessage] = useState("")


    async function editProfileDetails(e) {
        e.preventDefault();

        try {
            const data = {
                name: name
            }
            const authorRef = await firestore.collection("authors").doc(author.id).update(data);
            
        } catch (error) {
            
        }
    }



    return (

        <form onSubmit={editProfileDetails}>
            <label>Navn</label>
            <input value={name} onChange={e => setName(e.target.value)} className="form-control mb-2" placeholder="Navn" />
            {message && <div>{message}</div>}
            <button className="btn btn-primary">Oppdater</button>
        </form>

    )
}
export default EditProfileDetails